(() => {
  const body = document.body;

  const formatMoney = (cents, format = '${{amount}}') => {
    const number = Number(cents || 0);
    const withDelimiters = (value, precision = 2, thousands = ',', decimal = '.') => {
      const fixed = (value / 100).toFixed(precision);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return precision ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
    };
    const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
    const values = {
      amount: withDelimiters(number),
      amount_no_decimals: withDelimiters(number, 0),
      amount_with_comma_separator: withDelimiters(number, 2, '.', ','),
      amount_no_decimals_with_comma_separator: withDelimiters(number, 0, '.', ','),
      amount_with_apostrophe_separator: withDelimiters(number, 2, "'", '.')
    };
    return format.replace(/\{\{\s*\w+\s*\}\}/, values[placeholder] || values.amount);
  };

  const show = (element) => {
    if (!element) return;
    element.hidden = false;
    body.classList.add('is-locked');
  };

  const hide = (element) => {
    if (!element) return;
    element.hidden = true;
    if (!document.querySelector('.pl-drawer:not([hidden]), .pl-search:not([hidden])')) {
      body.classList.remove('is-locked');
    }
  };

  const menu = document.querySelector('[data-menu-drawer]');
  const menuButton = document.querySelector('[data-menu-open]');
  menuButton?.addEventListener('click', () => {
    show(menu);
    menuButton.setAttribute('aria-expanded', 'true');
  });
  document.querySelectorAll('[data-menu-close]').forEach((button) => {
    button.addEventListener('click', () => {
      hide(menu);
      menuButton?.setAttribute('aria-expanded', 'false');
    });
  });

  const search = document.querySelector('[data-search-modal]');
  document.querySelector('[data-search-open]')?.addEventListener('click', () => {
    show(search);
    requestAnimationFrame(() => search?.querySelector('input[type="search"]')?.focus());
  });
  document.querySelectorAll('[data-search-close]').forEach((button) => {
    button.addEventListener('click', () => hide(search));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    hide(menu);
    hide(search);
    document.querySelector('[data-media-dialog][open]')?.close();
  });

  document.querySelectorAll('[data-announcement]').forEach((bar) => {
    const slides = [...bar.querySelectorAll('[data-announcement-slide]')];
    if (slides.length < 2) return;
    let index = 0;
    const activate = (nextIndex) => {
      slides[index].classList.remove('is-active');
      index = (nextIndex + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    };
    bar.querySelector('[data-announcement-prev]')?.addEventListener('click', () => activate(index - 1));
    bar.querySelector('[data-announcement-next]')?.addEventListener('click', () => activate(index + 1));
    const speed = Number(bar.dataset.speed) || 5000;
    window.setInterval(() => activate(index + 1), speed);
  });

  document.querySelectorAll('.pl-quantity').forEach((quantity) => {
    const input = quantity.querySelector('input');
    quantity.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min) || 1, Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    quantity.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-volume-offer]').forEach((offer) => {
    const productRoot = offer.closest('[data-product-root]');
    const quantityInput = productRoot?.querySelector('input[name="quantity"]');
    const currentPrice = productRoot?.querySelector('[data-volume-current-price]');
    const comparePrice = productRoot?.querySelector('[data-volume-compare-price]');
    const summary = offer.querySelector('[data-volume-summary]');
    const options = [...offer.querySelectorAll('[data-volume-option]')];
    if (!quantityInput || !currentPrice || !comparePrice || !summary || !options.length) return;

    const unitPrice = Number(offer.dataset.unitPrice || 0);
    const compareUnit = Number(offer.dataset.compareUnit || unitPrice);
    const buyTwoDiscount = Number(offer.dataset.buyTwoDiscount || 10);
    const buyThreeDiscount = Number(offer.dataset.buyThreeDiscount || 15);
    const moneyFormat = offer.dataset.moneyFormat || '${{amount}}';

    const update = () => {
      const quantity = Math.max(1, Number(quantityInput.value || 1));
      const discount = quantity >= 3 ? buyThreeDiscount : quantity === 2 ? buyTwoDiscount : 0;
      const total = Math.round(unitPrice * quantity * (100 - discount) / 100);
      const regularTotal = compareUnit * quantity;
      const activeQuantity = quantity >= 3 ? 3 : quantity;
      const activeOption = options.find((option) => Number(option.dataset.quantity) === activeQuantity);

      currentPrice.textContent = formatMoney(total, moneyFormat);
      comparePrice.textContent = formatMoney(regularTotal, moneyFormat);
      comparePrice.hidden = regularTotal <= total;
      options.forEach((option) => option.setAttribute('aria-pressed', String(option === activeOption)));
      summary.textContent = activeOption?.dataset.summary || `${quantity} items · Save ${discount}%`;
    };

    options.forEach((option) => {
      option.addEventListener('click', () => {
        quantityInput.value = option.dataset.quantity || '1';
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    quantityInput.addEventListener('change', update);
    quantityInput.addEventListener('input', update);
    update();
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const media = [...gallery.querySelectorAll('[data-product-media]')];
    const current = gallery.querySelector('[data-gallery-current]');
    if (media.length < 2) return;
    let index = 0;
    const activate = (nextIndex) => {
      media[index].classList.remove('is-active');
      index = (nextIndex + media.length) % media.length;
      media[index].classList.add('is-active');
      if (current) current.textContent = String(index + 1);
    };
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => activate(index - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => activate(index + 1));
  });

  document.querySelectorAll('[data-product-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-product-track]');
    const cards = [...track?.children || []];
    if (!track || cards.length <= 4) return;
    let page = 0;
    const update = () => {
      const gap = 30;
      const cardWidth = cards[0].getBoundingClientRect().width;
      track.style.transform = `translateX(-${page * (cardWidth + gap) * 4}px)`;
    };
    slider.querySelector('[data-product-prev]')?.addEventListener('click', () => {
      page = Math.max(0, page - 1);
      update();
    });
    slider.querySelector('[data-product-next]')?.addEventListener('click', () => {
      page = Math.min(Math.ceil(cards.length / 4) - 1, page + 1);
      update();
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth < 990) track.style.transform = '';
      else update();
    });
  });

  const mediaDialog = document.querySelector('[data-media-dialog]');
  document.querySelector('[data-media-zoom]')?.addEventListener('click', () => mediaDialog?.showModal());
  document.querySelector('[data-media-close]')?.addEventListener('click', () => mediaDialog?.close());
  mediaDialog?.addEventListener('click', (event) => {
    if (event.target === mediaDialog) mediaDialog.close();
  });

  document.querySelectorAll('[data-share-url]').forEach((button) => {
    button.addEventListener('click', async () => {
      const url = button.dataset.shareUrl;
      if (navigator.share) {
        await navigator.share({ title: document.title, url }).catch(() => {});
        return;
      }
      await navigator.clipboard?.writeText(url);
      const original = button.textContent;
      button.textContent = 'Link copied';
      window.setTimeout(() => { button.textContent = original; }, 1600);
    });
  });

  const toast = document.querySelector('[data-cart-toast]');
  document.querySelector('[data-toast-close]')?.addEventListener('click', () => { toast.hidden = true; });

  document.querySelectorAll('form[data-ajax-cart]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"][name="add"]');
      submit?.setAttribute('disabled', 'disabled');
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Add to cart failed');
        const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((count) => {
          count.textContent = String(cart.item_count);
          count.hidden = cart.item_count === 0;
        });
        if (toast) {
          toast.hidden = false;
          window.setTimeout(() => { toast.hidden = true; }, 4200);
        }
      } catch (error) {
        HTMLFormElement.prototype.submit.call(form);
      } finally {
        submit?.removeAttribute('disabled');
      }
    });
  });
})();
